import React, {useContext, useState} from 'react'
import client from "../images/photo2.jpg";
import {useTranslation} from "react-i18next";
import {Carcontext} from "../context/carcontext";
import {useDispatch} from "react-redux";
import {acceptTgClient, declineTgClient, showAlert} from "../redux/actions";

const TelegramClient = ({person, index}) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const {OpenUserModal} = useContext(Carcontext)
    const [message, setMessage] = useState({})
    const [showMessage, setShowMessage] = useState(false)

    function acceptClient(event, id) {
        event.stopPropagation()
        dispatch(acceptTgClient(id))
    }

    function declineClient(event, id) {
        event.stopPropagation()
        if (JSON.stringify(message) === '{}') {
            dispatch(showAlert(`You did not select a message`, `warning`))
        } else {
            dispatch(declineTgClient(id, message))
            closeMessages(event)
        }
    }

    function closeMessages(event) {
        event.stopPropagation()
        setShowMessage(false)
    }

    function showMessages(event) {
        event.stopPropagation()
        setShowMessage(true)
    }

    function handleMessage(event) {
        setMessage({...message, [event.target.name]: event.target.value})
    }

    if (showMessage) {
        return (
            <div className="client tg">
                <div className="response-messages" id={`${index}`} onClick={event => event.stopPropagation()} onMouseLeave={closeMessages}>
                    <div className="response-messages-item">
                        <input type="radio" id="messageOne" name="message" value={`${t('declineMessageOne')}`} onChange={handleMessage}/>
                        <label htmlFor="messageOne">{t('declineMessageOne')}</label>
                    </div>
                    <div className="response-messages-item">
                        <input type="radio" id="messageTwo" name="message" value={`${t('declineMessageTwo')}`} onChange={handleMessage}/>
                        <label htmlFor="messageTwo">{t('declineMessageTwo')}</label>
                    </div>
                    <div className="response-messages-item">
                        <input type="radio" id="messageThree" name="message" value={`${t('declineMessageThree')}`} onChange={handleMessage}/>
                        <label htmlFor="messageThree">{t('declineMessageThree')}</label>
                    </div>
                    <div className="buttons">
                        <button className="cancel" onClick={event => closeMessages(event)}>{t('cancel')}</button>
                        <button className="decline" onClick={event => declineClient(event, person.client_id)}>{t('decline')}</button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={`client`} onClick={() => OpenUserModal(person)} key={index}>
            <div className="client-body">
                <div className="client-imagebox">
                    <img src={person.photo} alt="client: client" className="client-image" />
                </div>
                <div className="client-info">
                    <h3 className="client-surname">{person.lastname}</h3>
                    <h3 className="client-name">{person.firstname}</h3>
                    <div className="client-sensor">
                        <div className="client-sensor-color pending"></div>
                        <p className="client-sensor-value">{t('pending')}</p>
                    </div>
                </div>
            </div>
            <p className="client-number">{person.passport_series}</p>
            <div className="buttons">
                <button className="accept" onClick={event => acceptClient(event, person.client_id)}>{t('accept')}</button>
                <button className="decline" onClick={event => showMessages(event)}>{t('decline')}</button>
            </div>
        </div>
    )
}

export default TelegramClient